import { useMutation, useQueryClient } from '@tanstack/react-query';
import { agentsApi, UpdateAIAgentRequest, AIAgentResponse } from '../services/agentsApi';
import { toast } from 'sonner';

/**
 * Hook para atualizar agente existente
 *
 * @example
 * const updateAgent = useUpdateAgent();
 *
 * const handleSave = async () => {
 *   try {
 *     await updateAgent.mutateAsync({ id: agentId, data: updatedData });
 *     navigate('/automation/ai-agents');
 *   } catch (error) {
 *     // Error já tratado automaticamente
 *   }
 * };
 */
export const useUpdateAgent = () => {
  const queryClient = useQueryClient();

  return useMutation<
    AIAgentResponse,
    Error,
    { id: string; data: UpdateAIAgentRequest; overrideReason?: string }
  >({
    mutationFn: ({ id, data, overrideReason }) =>
      agentsApi.update(id, data, overrideReason),
    onSuccess: (_, variables) => {
      // Invalidate queries para refetch
      queryClient.invalidateQueries({ queryKey: ['ai-agents'] });
      queryClient.invalidateQueries({ queryKey: ['ai-agent', variables.id] });
      queryClient.invalidateQueries({ queryKey: ['agent-versions', variables.id] });
      toast.success('Agente atualizado com sucesso!');
    },
    onError: (error) => {
      toast.error(`Erro ao atualizar agente: ${error.message}`);
    },
  });
};
